export default {
    namespaced: true,

    state: {
        actions: [],
    },

    mutations: {
        addOne(state, callback) {
            state.actions.push(callback)
        },

        removeOne(state, callback) {
            const index = state.actions.indexOf(callback)

            if (index !== -1) {
                state.actions.splice(index, 1)
            }
        },
    },

    getters: {
        getNext(state) {
            return state.actions[state.actions.length - 1]
        },
    },

    actions: {
        addOne(Store, callback) {
            Store.commit('addOne', callback)
        },

        removeOne(Store, callback) {
            Store.commit('removeOne', callback)
        },

        invokeNext(Store) {
            const nextAction = Store.getters.getNext

            if (nextAction) {
                nextAction()
                Store.dispatch('removeOne', nextAction)
            }
        },
    },
}
